if (!localStorage.getItem('lang')) {
  localStorage.setItem('lang', 'ru');
}

export default {
  lang: window.localStorage.getItem('lang'),
};
